document.addEventListener("DOMContentLoaded", function () {
  const expandableItems = document.querySelectorAll(
    ".water-height-state__station"
  );

  expandableItems.forEach((item) => {
    const button = item.querySelector(".water-height-state__toggle-btn");

    button.addEventListener("click", function () {
      const detailsWrapper = item.querySelector(
        ".water-height-state__details-wrapper"
      );
      const buttonText = button.querySelector(
        ".water-height-state__toggle-text"
      );

      const isExpanded = button.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        button.setAttribute("aria-expanded", "false");
        buttonText.textContent = "Więcej";
        detailsWrapper.setAttribute("aria-hidden", "true");
        detailsWrapper.classList.remove("expanded");
        manageTabIndex(detailsWrapper, true);
      } else {
        button.setAttribute("aria-expanded", "true");
        buttonText.textContent = "Mniej";
        detailsWrapper.setAttribute("aria-hidden", "false");
        detailsWrapper.classList.add("expanded");
        manageTabIndex(detailsWrapper, false);
      }
    });
  });
});

function manageTabIndex(container, isDisabled) {
  const focusableElements = container.querySelectorAll(
    'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
  );

  focusableElements.forEach((element) => {
    if (isDisabled) {
      element.setAttribute("tabindex", "-1");
    } else {
      element.removeAttribute("tabindex");
    }
  });
}
